import { useState } from 'react';
import { getDownloadSampleInstrumentUrl } from "./helpers";

export function useSampleDownloadSelector() {
    const [selectedItems, setSelectedItems] = useState([]);

    const toggleSelectedItem = (item, state) => {
        if (state) {
            setSelectedItems([...selectedItems, Number(item)])
        } else {
            setSelectedItems(selectedItems.filter(x => x != Number(item)))
        }
    }

    const getDownloadSelectedUrl = (productId) => {
        if (selectedItems.length && productId) {
            return getDownloadSampleInstrumentUrl(productId, selectedItems)
        }

        return null
    }

    const getDownloadSampleInstrumentUrlForSpecificInstrument = (productId, instrumentId) => {
        if (productId && instrumentId) {
            return getDownloadSampleInstrumentUrl(productId, [instrumentId]);
        }

        return null;
    }

    return { getDownloadSelectedUrl, toggleSelectedItem, getDownloadSampleInstrumentUrlForSpecificInstrument, selectedItems }
}
